export const getTranslatedStatus = (status) => {
    const statusMap = {
      0: "En cola",
      1: "Procesando",
      2: "Completado",
      3: "Error",
    };
    return statusMap[status] || "Estado desconocido";
  };
  
  export const STATUS_CODES = {
    QUEUED: 0,
    PROCESSING: 1,
    COMPLETED: 2,
    ERROR: 3
  };